import { render, staticRenderFns } from "./Tissues.vue?vue&type=template&id=585139fb&"
import script from "./Tissues.vue?vue&type=script&lang=js&"
export * from "./Tissues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports